export default "__VITE_ASSET__BWPqyqQb__"